import { FC } from 'react';

import { useAppSelector } from '@/store/hooks';

import * as Styled from './styled';

export const BasketIsAllowedBlock: FC = () => {
    const { auth, isNewQuestionnaireAllowed } = useAppSelector((state) => state.user);

    if (
        !auth.authenticated ||
        !isNewQuestionnaireAllowed ||
        (isNewQuestionnaireAllowed && isNewQuestionnaireAllowed.answer)
    ) {
        return <></>;
    }

    return (
        <Styled.BasketIsAllowedBlockWrapper>
            <div className="text">
                <span className="smile">😼</span>
                {isNewQuestionnaireAllowed.reason}
                {' 🤗'}
            </div>
        </Styled.BasketIsAllowedBlockWrapper>
    );
};
